import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full px-4 sm:px-6 lg:px-[118px] mb-[64px]">
      <div className="w-full max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 lg:gap-0">
          
          {/* Left Section - Logo and Description */}
          <div className="flex flex-col gap-[64px] w-full lg:w-[34%]">
            {/* Logo and Description */}
            <div className="flex flex-col gap-[12px] items-start w-full lg:w-[86%]">
              {/* Logo */}
              <div className="flex items-center">
                <img 
                  src="/images/averpact-logo-full.svg" 
                  alt="AverPact" 
                  className="h-16 w-auto"
                />
              </div>
              
              {/* Description */}
              <p className="text-base font-normal leading-[20px] text-left text-brown-dark w-full">
                A non-custodial, milestone-based escrow platform powered by smart contracts.
              </p>
            </div>

            {/* Footer Links - Hidden per request */}
            <div className="hidden">
              <a 
                href="/teams" 
                className="text-base font-normal leading-[21px] text-center text-brown-dark hover:text-primary-orange transition-colors"
              >
                Teams
              </a>
              
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-6 w-full sm:w-[80%]">
                <a 
                  href="/faqs" 
                  className="text-base font-normal leading-[21px] text-center text-brown-dark hover:text-primary-orange transition-colors"
                >
                  FAQs
                </a>
                <a 
                  href="/terms" 
                  className="text-base font-normal leading-[21px] text-center text-brown-dark hover:text-primary-orange transition-colors"
                >
                  Terms of Service
                </a>
                <a 
                  href="/privacy" 
                  className="text-base font-normal leading-[21px] text-center text-brown-dark hover:text-primary-orange transition-colors"
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>

          {/* Right Section - Social Links and Copyright */}
          <div className="flex flex-col gap-[64px] items-center lg:items-end w-full lg:w-[22%]">
            {/* Social Media Icons - hidden */}

            {/* Copyright */}
            <p className="text-base font-normal leading-[21px] text-center text-brown-dark">
              ©AverPact 2025. All rights reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;